module.exports = __webpack_public_path__ + "img/screen_11.046481a1.svg";